module.exports = __webpack_public_path__ + "static/img/15areaA_2.6ccef6e.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/15areaA_2.png
// module id = 896
// module chunks = 1